import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { useHistory } from 'react-router'
import "../css/signature.css"
import { FaCheckCircle } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";
import axios from 'axios';
import ScrollToTop from "react-scroll-to-top";
import ClipLoader from "react-spinners/ClipLoader";
import moment from 'moment';
import { BsInfoCircleFill } from "react-icons/bs";
import SignatureCanvas from 'react-signature-canvas'
import $ from "jquery";
import Swal from 'sweetalert2'
import { Rnd } from "react-rnd";
import { ThreeDots } from 'react-loader-spinner'
import 'axios-progress-bar/dist/nprogress.css'
import { HexColorPicker } from "react-colorful";
import { IoColorPaletteSharp } from "react-icons/io5";

const Signature = (props) => {
    const [color, setColor] = useState("#000");
    const history = useHistory();
    const sigPad = useRef({})
    const [uploadLoader, setUploadLoader] = useState(false)
    const [base64, setbase64] = useState()
    const [name, setName] = useState()
    const [email, setEmail] = useState()
    const [place, setPlace] = useState()
    const [sign64, setsign64] = useState("")
    const [local_file_type, set_local_file_type] = useState()
    const [image_state, set_img_state] = useState("choosen_image_1")
    const [fileNamee, setfileName] = useState()
    const [secured_at, setTime] = useState()
    const [text, setText] = useState("Draw signature:")
    const [showw, setShow] = useState("")
    const [btnText, setBtnText] = useState('Draw signature:')
    const [fileData, set_fileData] = useState()
    const [modal, setModal] = useState()
    const [nameOfFile, setNameOfFile] = useState()
    const [displayTime, setDisplayTime] = useState("")
    const [placestate, setplacestate] = useState("")
    const [specified, setspecified] = useState("hide_specified")
    const [place_color, set_place_color] = useState("")
    const [loader, setLoader] = useState()
    const [pdfarray, setpdfarray] = useState([])
    const allData = props.location.state
    const [progressValue, setProgressValue] = useState(0)
    const [uploadStatus, setUploadStatus] = useState("Your document is being uploaded and encrypted")
    let data = '';

    const getLocalPosition = () => {
        const position = localStorage.getItem('homeButtonPosition')
        const positionJSON = (position && JSON.parse(position)) || {}
        return {
            x: positionJSON.x || 0,
            y: positionJSON.y || 0
        }
    }
    const [intervalId, setIntervalId] = useState(0);

    useEffect(() => {
        if (allData !== undefined) {

            if (allData.fileType === "image/png" || allData.fileType === "image/jpeg" || allData.fileType === "image/jpg") {
                const arrayData = allData.image.array
                setbase64(arrayData[0])
                setpdfarray(arrayData)
            }
            else {
                const arrayData = allData.image.tempArr
                setpdfarray(arrayData)
                setbase64(arrayData[0])
            }
            // set_img_state("choosen_image")
            const name_person = allData.name_
            setName(name_person)

            const email_person = allData.email
            setEmail(email_person)

            const typeFile = allData.fileType
            set_local_file_type(typeFile)

            const storing_time = allData.storeTime
            setDisplayTime(storing_time)

            if (!intervalId) {
                start()
            }
            const name_file = allData.total_files
            const main_file = name_file.name
            const remove_last = main_file.slice(0, -4)
            setNameOfFile(remove_last)

            setfileName(main_file)

            const place_person = allData.place
            const fetched = allData.places
            if (place_person == null || place_person == '') {
                setPlace(fetched)
                set_place_color("fetched_ltn")
                setplacestate(fetched)
            }
            else {
                setPlace(place_person)
                set_place_color("placee")
                setplacestate("")
            }

            if (local_file_type == "image/png" || local_file_type == "image/jpeg" || local_file_type == "image/jpg") {
                set_img_state("choosen_image_1")
            }
            else if (local_file_type == "application/pdf") {
                // set_img_state("choosen_image")
            }
            let togllablePlace = allData.places
            console.log('all',allData);
            if (togllablePlace === "") {
                setspecified("specified_text")
            }
            else {
                setspecified("hide_specified")
            }
        }
        else {
            history.push('/home')
        }
        $(".myColor").css('color', color);

    }, [local_file_type, place, secured_at, displayTime, allData, pdfarray, color])

    // useEffect(() => {
    //     if (allData !== undefined) {
    //         const arrayData = allData.image.pdfResponse
    //         if (allData.fileType === "image/png" || allData.fileType === "image/jpeg" || allData.fileType === "mage/jpg") {
    //             setbase64(allData.image.array[0])
    //             setpdfarray(allData.image.array)
    //         }
    //         else {
    //             setbase64(arrayData[0])
    //             setpdfarray(arrayData)
    //         }
    //         set_img_state("choosen_image")
    //         const name_person = allData.name_
    //         setName(name_person)

    //         const email_person = allData.email
    //         setEmail(email_person)

    //         const typeFile = allData.fileType
    //         set_local_file_type(typeFile)

    //         const storing_time = allData.storeTime
    //         setDisplayTime(storing_time)

    //         if (!intervalId) {
    //             start()
    //         }
    //         const name_file = allData.total_files
    //         const main_file = name_file.name
    //         const remove_last = main_file.slice(0, -4)
    //         setNameOfFile(remove_last)

    //         setfileName(main_file)

    //         const place_person = allData.place
    //         const fetched = allData.places

    //         if (place_person == null || place_person == '') {
    //             setPlace(fetched)
    //             set_place_color("fetched_ltn")
    //             setplacestate(fetched)
    //         }
    //         else {
    //             setPlace(place_person)
    //             set_place_color("placee")
    //             setplacestate("")
    //         }

    //         if (local_file_type == "image/png" || local_file_type == "image/jpeg" || local_file_type == "image/jpg") {
    //             set_img_state("choosen_image_1")
    //         }
    //         else if (local_file_type == "application/pdf") {
    //             set_img_state("choosen_image")
    //         }

    //         if (placestate !== "") {
    //             setspecified("hide_specified")
    //         }
    //         else {
    //             setspecified("specified_text")
    //         }
    //     }
    //     else {
    //         history.push('/home')
    //     }
    //     $(".myColor").css('color', color);
    // }, [local_file_type, place, secured_at, displayTime, allData, pdfarray, color])

    const start = () => {
        let updated_API_time = moment(displayTime).valueOf();
        if (displayTime) {
            const newIntervalId = setInterval(() => {
                updated_API_time += 1000;
                const final_time = moment(updated_API_time).format("DD MMM YYYY hh:mm:ss a")
                setTime(final_time)
            }, 1000);
            setIntervalId(newIntervalId);
        }
    }
    const stoppp = () => {
        clearInterval(intervalId);
        setIntervalId(1);
        return;
    }
    const open_sign_box = (remove_text) => {
        setModal(!modal)
        set_fileData(remove_text);
    }
    const toggle_modal_box = () => {
        setModal(!modal)
    }
    function clear() {
        sigPad.current.clear();
    }
    const LinkElement = () => <span>
        Signed and secured using blockchain on <a href="https://www.lynksign.com/">lynksign.com</a> , visit to authenticate!
    </span>

    const save = () => {
        setModal(!modal)
        data = sigPad.current.toDataURL();
        if (data == "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAEsCAYAAAAfPc2WAAAAAXNSR0IArs4c6QAADuZJREFUeF7t1jERAAAIAzHq3zQmfgwCOuQYfucIECBAgAABAgRSgaVrxggQIECAAAECBE5geQICBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAIEHgNkBLevR78cAAAAASUVORK5CYII=") {
            setText("Draw signature:")
            setBtnText("Draw signature:")
            setsign64(data)
            setShow("")
        }
        else if (data == "data:image/png;base64,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") {
            setText("Draw signature:")
            setBtnText("Draw signature:")
            setsign64(data)
            setShow("")
        }
        else {
            setText("Signature:")
            setBtnText("Signature:")
            setsign64(data)
            setShow(LinkElement)
            $(".myColor").css('color', color);
        }
    }
    if (!modal) {
        document.body.classList.add('active_modal')
    } else {
        document.body.classList.remove('active_modal')
    }
    if (!loader) {
        document.body.classList.remove('active_modal')
    } else {
        document.body.classList.add('active_modal')
    }

    // *****************download****************
    const downloadAttachment = async () => {
        if (text == "Draw signature:") {
            Swal.fire({
                position: 'bottom',
                icon: 'info',
                title: 'Please draw your signature',
                showConfirmButton: false,
                timer: 1500
            })
        }
        else if (text == "Signature:") {
            stoppp()
            const final_data = { name, email, secured_at, place, fileNamee, fileData }
            const slides = document.getElementsByClassName("tableToPrint");
            let count = slides.length;
            let i = 0;
            let indexGloabal = 0;
            if (local_file_type === 'image/jpeg') {
                var fileName = new Date().getTime() + ".jpeg"
            }
            else if (local_file_type === 'image/jpg') {
                var fileName = new Date().getTime() + ".jpg"
            }
            else if (local_file_type === 'image/png') {
                var fileName = new Date().getTime() + ".png"
            }
            else if (local_file_type === 'application/pdf') {
                var fileName = new Date().getTime() + ".pdf"
            }
            var fileNameArr = [fileName];
            uploadRecur(i, (count - 1), indexGloabal, fileName, final_data, fileNameArr);
            return;

        }
    }
    async function uploadRecur(i, count, indexGloabal, fileName, final_data, fileNameArr) {
        setUploadLoader(true)
        for (var i = 0; i < count; i++) {
            const getElementLength = document.getElementsByClassName("tableToPrint");
            let pagesLength = getElementLength.length;
            let intervals = Math.floor(100 / pagesLength)
            setProgressValue((progressValue) => progressValue + intervals)
        }

        const input = document.getElementById('printMe');
        return await html2canvas(input, { scale: "2" })
            .then(async (canvas) => {
                if (local_file_type === "application/pdf") {
                    setUploadLoader(true)
                    var imgData = await canvas.toDataURL('image/jpeg', 1)
                    var doc = new jsPDF('p', 'mm', 'a4', true);
                    var position = 0;
                    const imgProps = doc.getImageProperties(imgData);
                    const pdfWidth = doc.internal.pageSize.getWidth();
                    const height = doc.internal.pageSize.getHeight();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width - 1

                    var heightLeft = pdfHeight;
                    doc.addImage(imgData, 'JPEG', 0, position, pdfWidth, (pdfHeight + 0), undefined, 'FAST');
                    heightLeft -= height;
                    while (heightLeft >= 0) {
                        position = heightLeft - pdfHeight;
                        doc.addPage();
                        doc.addImage(imgData, 'JPEG', 0, position, pdfWidth, (pdfHeight + 0), undefined, 'FAST');
                        heightLeft -= height;
                    }
                    const datauristring = doc.output('datauristring')
                    var sizeCheck = datauristring.length / 1000000
                    if (8 < sizeCheck) {
                        Swal.fire({
                            position: 'bottom',
                            icon: 'info',
                            title: 'File size exceeded. Please go for Local Download',
                            showConfirmButton: false,
                            timer: 1500
                        })
                        setUploadLoader(false)
                        setProgressValue(0)
                    }
                    else {
                        const remove_text = datauristring.replace('data:application/pdf;filename=generated.pdf;base64,', '');
                        set_fileData(remove_text);
                        // /testing/ 
                        axios.defaults.baseURL = "https://signblock.lynksign.com";
                        var file = b64toBlob(remove_text)
                        let size = 1024 * 50;
                        let fileChunks = [];
                        for (let cur = 0; cur < file.size; cur += size) {
                            fileChunks.push({
                                hash: indexGloabal++,
                                chunk: file.slice(cur, cur + size),
                            });
                        }
                        // To upload
                        const uploadList = fileChunks.map((item, index) => {
                            let formData = new FormData();
                            formData.append("filename", fileName);
                            formData.append("hash", item.hash);
                            formData.append("chunk", item.chunk);
                            formData.append("index", indexGloabal);

                            return axios({
                                method: "post",
                                url: "/upload",
                                data: formData,
                            });
                        });

                        await Promise.all(uploadList);

                    }
                    await mergeF(indexGloabal, fileNameArr);
                }

                else {
                    setUploadLoader(true)
                    setProgressValue(100)
                    var imgData = canvas.toDataURL(`${local_file_type}`);
                    var doc = new jsPDF('p', 'mm', 'a4');
                    var position = 0;
                    const datauristring = imgData;
                    var sizeCheck = datauristring.length / 1000000
                    if (8 < sizeCheck) {
                        Swal.fire({
                            position: 'bottom',
                            icon: 'info',
                            title: 'File size exceeded. Please go for Local Download',
                            showConfirmButton: false,
                            timer: 1500
                        })
                        setUploadLoader(false)
                        setProgressValue(0)
                    }
                    else {
                        const remove_text = datauristring.replace(`data:${local_file_type};base64,`, '');
                        set_fileData(remove_text);

                        var file = b64toBlob(remove_text);
                        axios.defaults.baseURL = "https://signblock.lynksign.com";
                        let size = 1024 * 50; //50KB 50KB Section size
                        let fileChunks = [];
                        let index = 0; //Section num
                        for (let cur = 0; cur < file.size; cur += size) {
                            fileChunks.push({
                                hash: index++,
                                chunk: file.slice(cur, cur + size),
                            });
                        }
                        // To upload
                        const uploadList = fileChunks.map((item, index) => {
                            let formData = new FormData();
                            formData.append("filename", fileName);
                            formData.append("hash", item.hash);
                            formData.append("chunk", item.chunk);
                            return axios({
                                method: "post",
                                url: "https://signblock.lynksign.com/upload",
                                data: formData,
                            });
                        });
                        await Promise.all(uploadList);
                        // All tasks complete, merge slices
                    }
                    await mergeF(indexGloabal, fileNameArr);
                }

                // if (i < count) {
                //     var newFileName = new Date().getTime() + ".pdf";
                //     fileNameArr.push(newFileName);
                //     await uploadRecur((i + 1), count, 0, newFileName, final_data, fileNameArr);
                // }
                // if (i == count) {
                //     await mergeF(indexGloabal, fileNameArr);
                // }
                // await mergeF(indexGloabal, fileNameArr);
            })
    }
    async function mergeF(indexGloabal, fileName) {
        setUploadStatus('The transaction is now being written on the blockchain ledger')
        indexGloabal = 0;
        if (local_file_type === "application/pdf") {
            let result = await axios({
                method: "post",
                url: "/merge",
                data: {
                    filename: fileName,
                    "email": email,
                    "fileName": fileNamee,
                    "name": name,
                    "place": place,
                    "secured_at": secured_at,
                    "fileData": "",
                    "createdFileName": "",
                    localDownload: 'no'

                }
            })
            let message = result.data.message
            let pdfLocation = result.data.filename
            setProgressValue(100)
            localDownloadImage(pdfLocation, fileNamee)

            setUploadLoader(false);
            if (message === "Success") {
                setProgressValue(0)
                setUploadStatus('Your document is being uploaded and encrypted')
            }
        }
        else {
            let res = await axios({
                method: "post",
                url: "https://signblock.lynksign.com/merge/image",
                data: {
                    filename: fileName,
                    "email": email,
                    "fileName": fileNamee,
                    "name": name,
                    "place": place,
                    "secured_at": secured_at,
                    "fileData": "",
                    "createdFileName": "",
                    localDownload: 'no'
                }
            });
            setUploadLoader(false)
            let message = res.data.message
            let pdfLocation = res.data.filename
            setProgressValue(100)
            localDownloadImage(pdfLocation, fileNamee)
            if (message === "Success") {
                setProgressValue(0)
                setUploadStatus('Your document is being uploaded and encrypted')
            }
        }
    }
    function localDownloadImage(url, fileNamee) {
        fetch(url)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = fileNamee;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Check your mail for Txn ID. Your file has been secured successfully.',
                    showConfirmButton: false,
                    timer: 1500
                })
                setTimeout(() => {
                    history.push('/home')
                }, 2000)
            })
            .catch((err) => {
                console.log('err', err);
                alert('An error sorry')
            });
    }
    // *********************

    // **************Local Download**************
    const Download = async () => {
        if (text == "Draw signature:") {
            Swal.fire({
                position: 'bottom',
                icon: 'info',
                title: 'Please draw your signature',
                showConfirmButton: false,
                timer: 1500
            })
        }
        else if (text == "Signature:") {
            stoppp()
            const final_data = { name, email, secured_at, place, fileNamee, fileData }
            const slides = document.getElementsByClassName("tableToPrint");
            let count = slides.length;
            let i = 0;
            let indexGloabal = 0;
            if (local_file_type === 'image/jpeg') {
                var fileName = new Date().getTime() + ".jpeg"
            }
            else if (local_file_type === 'image/jpg') {
                var fileName = new Date().getTime() + ".jpg"
            }
            else if (local_file_type === 'image/png') {
                var fileName = new Date().getTime() + ".png"
            }
            else if (local_file_type === 'application/pdf') {
                var fileName = new Date().getTime() + ".pdf"
            }
            var fileNameArr = [fileName];
            uploadRecurNew(i, (count - 1), indexGloabal, fileName, final_data, fileNameArr);
            return;

        }
    }
    async function uploadRecurNew(i, count, indexGloabal, fileName, final_data, fileNameArr) {
        setUploadLoader(true)
        for (var i = 0; i < count; i++) {
            const getElementLength = document.getElementsByClassName("tableToPrint");
            let pagesLength = getElementLength.length;
            let intervals = Math.floor(100 / pagesLength)
            setProgressValue((progressValue) => progressValue + intervals)
        }
        const input = document.getElementById('printMe');
        return await html2canvas(input, { scale: "2" })
            .then(async (canvas) => {
                if (local_file_type === "application/pdf") {
                    setUploadLoader(true)
                    var imgData = await canvas.toDataURL('image/jpeg', 1)
                    var doc = new jsPDF('p', 'mm', 'a4', true);
                    var position = 0;
                    const imgProps = doc.getImageProperties(imgData);
                    const pdfWidth = doc.internal.pageSize.getWidth();
                    const height = doc.internal.pageSize.getHeight();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width - 1

                    var heightLeft = pdfHeight;
                    doc.addImage(imgData, 'JPEG', 0, position, pdfWidth, (pdfHeight + 0), undefined, 'FAST');
                    heightLeft -= height;
                    while (heightLeft >= 0) {
                        position = heightLeft - pdfHeight;
                        doc.addPage();
                        doc.addImage(imgData, 'JPEG', 0, position, pdfWidth, (pdfHeight + 0), undefined, 'FAST');
                        heightLeft -= height;
                    }
                    const datauristring = doc.output('datauristring')
                    var sizeCheck = datauristring.length / 1000000
                    const remove_text = datauristring.replace('data:application/pdf;filename=generated.pdf;base64,', '');
                    set_fileData(remove_text);
                    // /testing/ 
                    axios.defaults.baseURL = "https://signblock.lynksign.com";
                    var file = b64toBlob(remove_text)
                    let size = 1024 * 50;
                    let fileChunks = [];
                    for (let cur = 0; cur < file.size; cur += size) {
                        fileChunks.push({
                            hash: indexGloabal++,
                            chunk: file.slice(cur, cur + size),
                        });
                    }
                    // To upload
                    const uploadList = fileChunks.map((item, index) => {
                        let formData = new FormData();
                        formData.append("filename", fileName);
                        formData.append("hash", item.hash);
                        formData.append("chunk", item.chunk);
                        formData.append("index", indexGloabal);

                        return axios({
                            method: "post",
                            url: "/upload",
                            data: formData,
                        });
                    });

                    await Promise.all(uploadList);
                    await mergeFNew(indexGloabal, fileNameArr);
                }
                else {
                    setUploadLoader(true)
                    setProgressValue(100)
                    var imgData = canvas.toDataURL(`${local_file_type}`);
                    var doc = new jsPDF('p', 'mm', 'a4');
                    var position = 0;
                    const datauristring = imgData;
                    const remove_text = datauristring.replace(`data:${local_file_type};base64,`, '');
                    set_fileData(remove_text);

                    var file = b64toBlob(remove_text);
                    axios.defaults.baseURL = "https://signblock.lynksign.com";
                    let size = 1024 * 50; //50KB 50KB Section size
                    let fileChunks = [];
                    let index = 0; //Section num
                    for (let cur = 0; cur < file.size; cur += size) {
                        fileChunks.push({
                            hash: index++,
                            chunk: file.slice(cur, cur + size),
                        });
                    }
                    // To upload
                    const uploadList = fileChunks.map((item, index) => {
                        let formData = new FormData();
                        formData.append("filename", fileName);
                        formData.append("hash", item.hash);
                        formData.append("chunk", item.chunk);
                        return axios({
                            method: "post",
                            url: "https://signblock.lynksign.com/upload",
                            data: formData,
                        });
                    });
                    await Promise.all(uploadList);
                    // All tasks complete, merge slices
                    await mergeFNew(indexGloabal, fileNameArr);
                }
                // if (i < count) {
                //     var newFileName = new Date().getTime() + ".pdf";
                //     fileNameArr.push(newFileName);
                //     await uploadRecurNew((i + 1), count, 0, newFileName, final_data, fileNameArr)
                // }
                // if (i == count) {
                //     await mergeFNew(indexGloabal, fileNameArr);
                // }
            })
    }
    async function mergeFNew(indexGloabal, fileName) {
        setUploadStatus('The transaction is now being written on the blockchain ledger')
        indexGloabal = 0;
        if (local_file_type === "application/pdf") {
            let result = await axios({
                method: "post",
                url: "/merge",
                data: {
                    filename: fileName,
                    "email": email,
                    "fileName": fileNamee,
                    "name": name,
                    "place": place,
                    "secured_at": secured_at,
                    "fileData": "",
                    "createdFileName": "",
                    localDownload: 'yes'
                }
            })
            let message = result.data.message
            let pdfLocation = result.data.filename
            let nameOfFile = result.data.filename

            setProgressValue(100)
            downloadImage(pdfLocation, fileNamee, fileName, nameOfFile)

            setUploadLoader(false);
            if (message === "Success") {
                setProgressValue(0)
                setUploadStatus('Your document is being uploaded and encrypted')
            }
        }
        else {
            let res = await axios({
                method: "post",
                url: "https://signblock.lynksign.com/merge/image",
                data: {
                    filename: fileName,
                    "email": email,
                    "fileName": fileNamee,
                    "name": name,
                    "place": place,
                    "secured_at": secured_at,
                    "fileData": "",
                    "createdFileName": "",
                    localDownload: 'yes'
                }
            });
            setUploadLoader(false)
            let message = res.data.message
            let pdfLocation = res.data.filename
            let nameOfFile = res.data.filename
            setProgressValue(100)
            downloadImage(pdfLocation, fileNamee, fileName, nameOfFile)
            if (message === "Success") {
                setProgressValue(0)
                setUploadStatus('Your document is being uploaded and encrypted')
            }
        }
    }
    function downloadImage(url, fileNamee, fileName, nameOfFile) {
        fetch(url)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = fileNamee;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Check your mail for Txn ID. Your file has been secured successfully.',
                    showConfirmButton: false,
                    timer: 1500
                })
                setTimeout(() => {
                    history.push('/home')
                    clean(fileName, nameOfFile)
                }, 2000)

            })
            .catch((err) => {
                console.log('err', err);
                alert('An error sorry')
            });
    }
    async function clean(fileName, nameOfFile) {
        let res = await axios({
            method: "post",
            url: "https://signblock.lynksign.com/clean",
            data: {
                filename: fileName,
                fileName: nameOfFile
            }
        });
    }
    // *********************



    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    const ResizeEvent = (e, d) => {
        e.stopPropagation()
        let wdth = document.getElementById("dynamic").offsetWidth
        if (wdth >= 600) {
            $(".draggableText").css('font-size', '15px');
            $("#specified_text").css('font-size', '12px');
            $(".draggableTextSign").css('font-size', '13px');
            $(".draggableTextNew").css('font-size', '12px');
        }
        else if (wdth >= 500 && wdth <= 600) {
            $(".draggableText").css('font-size', '14px');
            $("#specified_text").css('font-size', '11px');
            $(".draggableTextSign").css('font-size', '12px');
            $(".draggableTextNew").css('font-size', '11px');
        }
        else if (wdth >= 400 && wdth <= 500) {
            $(".draggableText").css('font-size', '13px');
            $("#specified_text").css('font-size', '10px');
            $(".draggableTextSign").css('font-size', '11px');
            $(".draggableTextNew").css('font-size', '10px');
            $(".resizeableImg").css('width', '60px');
        }
        else if (wdth >= 300 && wdth <= 400) {
            $(".draggableText").css('font-size', '12px');
            $("#specified_text").css('font-size', '9px');
            $(".draggableTextSign").css('font-size', '10px');
            $(".draggableTextNew").css('font-size', '9px');
            $(".resizeableImg").css('width', '60px');
        }
        else if (wdth >= 200 && wdth <= 300) {
            $(".draggableText").css('font-size', '11px');
            $("#specified_text").css('font-size', '8px');
            $(".draggableTextSign").css('font-size', '9px');
            $(".draggableTextNew").css('font-size', '8px');
            $(".resizeableImg").css('width', '60px');
        }
        else if (wdth >= 150 && wdth <= 200) {
            $(".draggableText").css('font-size', '10px');
            $("#specified_text").css('font-size', '7px');
            $(".draggableTextSign").css('font-size', '9px');
            $(".draggableTextNew").css('font-size', '7px');
            $(".resizeableImg").css('width', '60px');
        }
        else if (wdth >= 130 && wdth <= 150) {
            $(".draggableText").css('font-size', '9px');
            $("#specified_text").css('font-size', '6px');
            $(".draggableTextSign").css('font-size', '7.5px');
            $(".draggableTextNew").css('font-size', '6px');
            $(".resizeableImg").css('width', '60px');
        }
        else if (wdth >= 100 && wdth <= 130) {
            $(".draggableText").css('font-size', '7.6px');
            $("#specified_text").css('font-size', '6px');
            $(".draggableTextSign").css('font-size', '7px');
            $(".draggableTextNew").css('font-size', '6px');
            $(".resizeableImg").css('width', '60px');
        }
        else if (wdth >= 90 && wdth <= 100) {
            $(".draggableText").css('font-size', '6.7px');
            $("#specified_text").css('font-size', '5.8px');
            $(".draggableTextSign").css('font-size', '6.2px');
            $(".draggableTextNew").css('font-size', '5px');
            $(".resizeableImg").css('width', '40px');
        }
        else if (wdth >= 75 && wdth <= 90) {
            $(".draggableText").css('font-size', '5.7px');
            $("#specified_text").css('font-size', '4.5px');
            $(".draggableTextSign").css('font-size', '5.4px');
            $(".draggableTextNew").css('font-size', '4.5px');
            $(".resizeableImg").css('width', '30px');
        }
        else if (wdth >= 60 && wdth <= 75) {
            $(".draggableText").css('font-size', '4.6px');
            $("#specified_text").css('font-size', '3.5px');
            $(".draggableTextSign").css('font-size', '4.1px');
            $(".draggableTextNew").css('font-size', '4px');
            $(".resizeableImg").css('width', '21px');
        }
        else if (wdth >= 48 && wdth <= 60) {
            $(".draggableText").css('font-size', '3.5px');
            $("#specified_text").css('font-size', '2.4px');
            $(".draggableTextSign").css('font-size', '3px');
            $(".draggableTextNew").css('font-size', '3px');
            $(".resizeableImg").css('width', '15px');
        }
        else if (wdth >= 20 && wdth <= 48) {
            $(".draggableText").css('font-size', '2.5px');
            $("#specified_text").css('font-size', '2px');
            $(".draggableTextSign").css('font-size', '2.2x');
            $(".draggableTextNew").css('font-size', '3.5px');
            $(".resizeableImg").css('width', '9px')
        }
        else {
            $(".draggableText").css('font-size', '1px');
            $("#specified_text").css('font-size', '1.3px');
            $(".draggableTextSign").css('font-size', '1px');
            $(".draggableTextNew").css('font-size', '1px');
            $(".resizeableImg").css('width', '5px');
        }
    }
    const openColorBox = () => {
        if ($(".model_content").hasClass("open")) {
            $(".model_content").removeClass("open")
            $(".model_content").addClass("close")
        }
        else {
            $(".model_content").removeClass("close")
            $(".model_content").addClass("open")
        }
    }
    const aftersAll = (e) => {
        setColor(e)
    }
    return (
        <>
            <ScrollToTop id="scrolling_to_top" smooth color="black" />
            <div className="div70"></div>
            <div className="sign_div">

                <div className="pdf_sign" id="printMe">
                    <div id="outerTableToPrint">
                        {pdfarray.map((item, index) => {
                            return (
                                <div className="tableToPrint" id={`tableToPrint-${index}`}>
                                    <img key={index} src={item} className={image_state} />
                                </div>
                            )
                        })}
                        <div className="boxElem" >
                            <Rnd
                                className='rnd'
                                id="dynamic"
                                default={{
                                    x: 0,
                                    y: 0,
                                    width: 300,
                                    height: 115
                                }}
                                onResizeStop={(e, d) => ResizeEvent(e, d)}
                            >
                                <p className="draggableText myColor">{name}</p>
                                <p className="draggableText myColor ">{email}</p>
                                <div className="adjust">
                                    <p className="draggableText myColor">{place}</p>
                                    <p className="draggableText adjust myColor" id={specified} >(user specified)</p>
                                </div>
                                <p className="draggableText myColor">{displayTime}</p>


                                <div className="signElem">
                                    <span className="draggableTextSign myColor">Signature</span>
                                    {sign64 !== '' ?
                                        <img id="imgId" className="resizeableImg" src={sign64} alt='' />
                                        : ''}
                                </div>
                                <span className="draggableTextNew" >{showw}</span>

                            </Rnd>
                        </div>
                    </div>
                </div>
















                <div className="Download">
                    {btnText === 'Draw signature:' ?
                        <button onClick={() => open_sign_box()} className="download_btn"> Draw Signature</button>
                        :
                        <button onClick={() => open_sign_box()} className="download_btn"> Edit Signature</button>
                    }
                    <button className='emailButton' style={{ marginRight: '15px' }}  >
                        <div className='button_text' onClick={() => downloadAttachment()}>Send file over Email</div>
                        {/* <div className='button_icon'>
                            <BsInfoCircleFill className="infoIcon" />
                            <div className="titleBox">
                                <span>"Using this option we will store the file on the blockchain nodes, however using local download will not. Choose what you find convenient" </span>
                            </div>
                        </div> */}
                    </button>
                    <button onClick={() => Download()} className="download_btn">Local Download</button>

                </div>

                {!modal && (
                    <div className="modal">
                        <div onClick={toggle_modal_box} className="overlay"></div>
                        <div className="model_content">
                            <div id="sign_area">
                                <h3>Signature</h3>
                                <SignatureCanvas
                                    ref={sigPad}
                                    penColor={color}
                                    canvasProps={{
                                        className: "singnatureCanvas"
                                    }}
                                />
                            </div>
                            <div className="group_btns">
                                <button className="save" onClick={save}> <FaCheckCircle id="save_icon" /></button>
                                <button className="clear" onClick={clear}> <FaTrashAlt id="delete" /></button>
                                <button className="pallate" onClick={openColorBox}><IoColorPaletteSharp className="pallateIcon" /></button>
                            </div>
                            <div className="colorPallateElem">
                                <HexColorPicker className="tray" color={color} onChange={(e) => aftersAll(e)} style={{ width: '63%' }} />
                            </div>
                            <button className="sigCloseBtn" onClick={toggle_modal_box}><FiX id="sigClose" /></button>
                        </div>
                    </div>
                )}
                {loader && (
                    <div className="Load">
                        <div className="loader_overlay"></div>
                        <div className="loader_content">
                            <ClipLoader color="#ff7200" size={40} />
                        </div>

                    </div>
                )}
                {uploadLoader === true ?
                    <div className="Load">
                        <div className="loader_overlay"></div>
                        <div className="hideAndSeek">
                            <progress className="progressBar" value={progressValue} max="100"></progress>
                            <span className="progressValueSpan">{progressValue}%</span>
                        </div>
                        <div className="loader_content displayFlexMe">
                            <span className="xxxl">{uploadStatus}</span>
                            <ThreeDots color="#ff7200" size={40} />
                        </div>

                    </div>
                    : ''
                }
            </div>
        </>
    );
};

export default Signature;
